import { createAsyncThunk, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 as uuid } from "uuid";

import { IToast } from "shared/components/Toast/types";
import { IStoreState } from "App/types";
import { IStatus } from "shared/types";

export interface IToastState {
  list: IToast[];
}

const initialState: IToastState = { list: [] };

const TOAST_DURATION = 3000;

export const addTemporaryToast = createAsyncThunk(
  "toasts/addTemporaryToast",
  async (
    {
      message,
      status,
    }: {
      message: string;
      status: IStatus;
    },
    { dispatch }
  ) => {
    const id = uuid();
    dispatch(addToast({ id, message, status }));

    setTimeout(() => dispatch(removeToast(id)), TOAST_DURATION);
  }
);

const toastSlice = createSlice({
  name: "toasts",
  initialState,
  reducers: {
    addToast: (state, { payload }: PayloadAction<IToast>) => {
      state.list = [payload, ...state.list];
    },
    removeToast: (state, { payload }: PayloadAction<string>) => {
      state.list = state.list.filter(({ id }) => id !== payload);
    },
  },
});

export const toastListSelector = createSelector(
  (state: IStoreState) => state.toasts,
  toasts => toasts.list || []
);

const { addToast, removeToast } = toastSlice.actions;
export const toastReducer = toastSlice.reducer;
